import UtilityFunctions from '@/common/UtilityFunctions.js';

export default {
  data() {
    return {
      mediaQueries: {
        isSmallOnly: UtilityFunctions.mq().isSmallOnly,
        isMediumUp: UtilityFunctions.mq().isMediumUp,
        isMediumOnly: UtilityFunctions.mq().isMediumOnly,
        isLargeUp: UtilityFunctions.mq().isLargeUp,
        isLargeOnly: UtilityFunctions.mq().isLargeOnly
      }
    };
  },
  mounted() {
    const utilityMediaQueries = UtilityFunctions.mediaQueries();

    // https://www.designcise.com/web/tutorial/how-to-fix-the-javascript-typeerror-matchmedia-addeventlistener-is-not-a-function

    // smallOnly
    if (utilityMediaQueries.smallOnly?.addEventListener) {
      utilityMediaQueries.smallOnly.addEventListener('change', () => {
        this.mediaQueries.isSmallOnly = UtilityFunctions.mq().isSmallOnly;
      });
    } else {
      utilityMediaQueries.smallOnly.addListener(() => {
        this.mediaQueries.isSmallOnly = UtilityFunctions.mq().isSmallOnly;
      });
    }

    // mediumUp
    if (utilityMediaQueries.mediumUp?.addEventListener) {
      utilityMediaQueries.mediumUp.addEventListener('change', () => {
        this.mediaQueries.isMediumUp = UtilityFunctions.mq().isMediumUp;
      });
    } else {
      utilityMediaQueries.mediumUp.addListener(() => {
        this.mediaQueries.isMediumUp = UtilityFunctions.mq().isMediumUp;
      });
    }

    // mediumOnly
    if (utilityMediaQueries.mediumOnly?.addEventListener) {
      utilityMediaQueries.mediumOnly.addEventListener('change', () => {
        this.mediaQueries.isMediumOnly = UtilityFunctions.mq().isMediumOnly;
      });
    } else {
      utilityMediaQueries.mediumOnly.addListener(() => {
        this.mediaQueries.isMediumOnly = UtilityFunctions.mq().isMediumOnly;
      });
    }

    // largeUp
    if (utilityMediaQueries.largeUp?.addEventListener) {
      utilityMediaQueries.largeUp.addEventListener('change', () => {
        this.mediaQueries.isLargeUp = UtilityFunctions.mq().isLargeUp;
      });
    } else {
      utilityMediaQueries.largeUp.addListener(() => {
        this.mediaQueries.isLargeUp = UtilityFunctions.mq().isLargeUp;
      });
    }

    // largeOnly
    if (utilityMediaQueries.largeOnly?.addEventListener) {
      utilityMediaQueries.largeOnly.addEventListener('change', () => {
        this.mediaQueries.isLargeOnly = UtilityFunctions.mq().isLargeOnly;
      });
    } else {
      utilityMediaQueries.largeOnly.addListener(() => {
        this.mediaQueries.isLargeOnly = UtilityFunctions.mq().isLargeOnly;
      });
    }
  }
};
